import { createContext, useContext, useState } from 'react'
import { useFileInputContext } from '@components/form/photos/FileInputContext'
import Icon from '@components/shared/Icon'
import Modal from '@components/modal/Modal'
import { SortableHandle } from 'react-sortable-hoc'

import styles from 'styles/add/SortableThumbnailsActions.module.css'

const ActionContext = createContext({})
const useActionContext = () => useContext(ActionContext)

const DragHandle = SortableHandle(() =>
    <span className={styles.action}><Icon>drag_handle</Icon></span>)

const Actions = {

    ActionContext: ({ children }) => {
        const { ImageEditor, files, setFiles,
            callbacks: { onFileEntry, onFileDelete, onFileEdit } = {}} = useFileInputContext()

        const [isEdited, setIsEdited] = useState(false)
        const editorAvailable = Boolean(ImageEditor)

        const edit = (fileObject) => setIsEdited(fileObject)
        const deleteFile = (fileObject) => {
            const { file, i } = fileObject
            const splicedFiles = files.slice(0, i).concat(files.slice(i + 1))
            if (onFileDelete) onFileDelete([file])
            setFiles(splicedFiles)
        }

        const editCallback = editorAvailable && ((blob) => {
            if (blob) {
                const { file, i: order } = isEdited
                const newFiles = [...files]
                const newFile = blob

                if (onFileEdit) onFileEdit([{ file, newFile }])
                if (onFileDelete) onFileDelete([file])

                newFiles[order] = newFile

                setFiles(onFileEntry
                    ? onFileEntry(newFiles)
                    : newFiles)
            }

            setIsEdited(false)
        })

        return (
            <div className={styles.wrap}>
                <ActionContext.Provider value={{
                    edit, deleteFile, editorAvailable }}>

                    { children }
                    { editorAvailable && (
                        <Modal open={isEdited} onClose={() => setIsEdited(false)} locked>
                            <ImageEditor
                                src={isEdited?.file?.preview}
                                callback={editCallback} />
                        </Modal> )}
                </ActionContext.Provider>
            </div>
        )
    },

    Actions: ({ file, order }) => {
        const { edit, deleteFile, editorAvailable } = useActionContext()
        const fileObject = { file, i: order }

        return (
            <div className={styles.actions}>
                    <DragHandle />
                { editorAvailable &&
                    <span onClick={() => edit(fileObject)} className={styles.action}><Icon>edit</Icon></span> }
                    <span onClick={() => deleteFile(fileObject)} className={styles.action}><Icon>delete_forever</Icon></span>
            </div>
        )
    }

}

export default Actions